import {LanguageKey, LanguageValue, ILanguageSample} from '../interface/language' 

export const listLanguageSelected: ILanguageSample[] = [
  {id: 1, value: LanguageValue.english, key: LanguageKey.english},
  {id: 2, value: LanguageValue.french, key: LanguageKey.french}
]